import { AudienceSection } from '../components/AudienceSection';
import { DownloadCta } from '../components/DownloadCta';
import { FaqSection } from '../components/FaqSection';
import { HeroSection } from '../components/HeroSection';
import { HowItWorksSection } from '../components/HowItWorksSection';
import { LimitsSection } from '../components/LimitsSection';
import { PrivacySection } from '../components/PrivacySection';
import { ProblemSection } from '../components/ProblemSection';
import { ProofLevelsSection } from '../components/ProofLevelsSection';
import { RecipientViewSection } from '../components/RecipientViewSection';
import { ReportSection } from '../components/ReportSection';
import { SolutionSection } from '../components/SolutionSection';
import { TrustLayersSection } from '../components/TrustLayersSection';
import { UseCasesSection } from '../components/UseCasesSection';
import { useSeo } from './useSeo';

export function HomePage() {
  useSeo('seo.home.title', 'seo.home.description');

  return (
    <main>
      <HeroSection />
      <HowItWorksSection />
      <RecipientViewSection />
      <UseCasesSection />
      <ProblemSection />
      <SolutionSection />
      <TrustLayersSection />
      <ProofLevelsSection />
      <LimitsSection />
      <PrivacySection />
      <ReportSection />
      <AudienceSection />
      <FaqSection />
      <DownloadCta />
    </main>
  );
}
